import {BaseModel} from "../base";

class AdminIntegrationImplementationModel extends BaseModel {
    constructor(data) {
        super(data);
    }

    $update(implementation) {
        return this.$put('self', {}, implementation);
    }

    $delete() {
        return this.$del('self');
    }
}

export {
    AdminIntegrationImplementationModel
}